import {createRouter, createWebHistory} from "vue-router";
import routes from "./routes";

const router = createRouter({
    routes,
    history: createWebHistory()
})

// router.beforeEach((to, from, next) => {
//     if (!localStorage.getItem("token")) {
//         if (to.path === "/login") {
//             next()
//         }
//         next("/login")
//     } else {
//         next()
//     }
// })

export default router
